$(document).ready(function () {
    $('.show_form').on('click', function (event) {
        event.preventDefault();

        document.querySelector('.modal .right').scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
        });

        $('.hidden-form').show();
        $("input[name='nome']").val($('.txt-nome').text());
        $("input[name='nome_atual']").val($('.txt-nome').text());
        $("input[name='cpf']").val($('.txt-cpf').text());
        $("input[name='cpf_atual']").val($('.txt-cpf').text());
        $("input[name='login_atual']").val($('.txt-login').text());
        $("input[name='rg']").val($('.txt-rg').text());
        $("input[name='telefone']").val($('.txt-telefone').text());
        $("input[name='email']").val($('.txt-email').text());
        $("input[name='endereco']").val($('.txt-endereco').text());
        $("input[name='logradouro']").val($('.txt-logradouro').text());
        $("input[name='numero']").val($('.txt-numero').text());
        $("input[name='complemento']").val($('.txt-complemento').text());
        $("input[name='pais']").val($('.txt-pais').text());
        $("input[name='bairro']").val($('.txt-bairro').text());
        $("input[name='cidade']").val($('.txt-cidade').text());
        $("input[name='uf']").val($('.txt-uf').text());
        $("input[name='cep']").val($('.txt-cep').text());
    });
});
